import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { combineClassNames, getMediaPath } from '../../../../app/functions';
import './index.scss';

const HoverButton = ({
    icon = '',
    text = '',
    hoverIcon = '',
    hoverText = '',
    className = '',
    onClick = () => {},
    showTextOnMobile = false,
}) => {
    const [inFocus, setInFocus] = useState(false);

    const deviceState = useSelector((store) => store.state.deviceState);
    const isMobile = (deviceState === 'mobile');

    const iconPath = inFocus ? hoverIcon : icon;
    const showText = showTextOnMobile || !isMobile;

    const onHover = () => setInFocus(true);
    const onBlur = () => setInFocus(false);

    return (
        <button
            className={combineClassNames(
                'hover-button-wrapper',
                className,
            )}
            onClick={onClick}
            onMouseEnter={onHover}
            onMouseLeave={onBlur}
        >
            <div className="icon-wrapper">
                <img src={getMediaPath(iconPath)} alt="/" className="icon" />
            </div>

            {showText && text}

            {!isMobile && hoverText && inFocus && (
                <div className="bubble">{hoverText}</div>
            )}
        </button>
    );
};

export default HoverButton;
